const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "MFHF_DSC_ENABLED_TYPES_RETRIEVED":
            return action.mfHfDscEnabledTypes;

        default:
            return state;
    }
}
